import { Config } from '../../inc/Config';
import { useTranslation } from "react-i18next";
// import {  } from 'react';

export default async function Fetch(url, post) {

    
    const requestOptions = {
        method: 'POST',
        credentials : "include",
        signal: AbortSignal.timeout(30000),
        headers: {  
            'Content-Type': 'application/json', 
        },
        body: JSON.stringify(post)
    };
    
    try {

        const res = await fetch(Config.domain+url, requestOptions);
        if (res.status != 200) {

            if(res.status === 400){
                // _callback({error: "no data"});
                return {error: "no data"};
            } else if(res.status === 401){ 
                // _callback({error: "login"});
                return {error: "login"};
            } else if(res.status === 404){ 
                // _callback({error: "not found"});
                return {error: "not found"};
            } else {
                
                return {error: res};
            }

        } else {

            const data = await res?.json();
            return data;
        }
    } catch(e) {
        console.log(e);
        return {error: "error"};
    }
}

export async function user_login(data) {

    let res = await Fetch("login", data);
    
    return res
}

export async function user_logout() {

    let res = await Fetch("logout");
    
    return res
}

export async function Get(url, post) {

    
    const requestOptions = {
        method: 'GET',
        credentials : "include",
        signal: AbortSignal.timeout(30000),
        headers: {  
            'Content-Type': 'application/json', 
        },
        body: post
    };

    try {

        const res = await fetch(Config.domain+url, requestOptions);
        const data = await res?.json();
        return data;
        
    } catch(e) {
        console.log(e);
        return {error: "error"};
    }
}


// export async function FetchCache(url, post) {

//     const requestOptions = {
//         method: 'POST',
//         credentials : "include",
//         signal: AbortSignal.timeout(30000),
//         headers: {  
//             'Content-Type': 'application/json', 
//         },
//         body: JSON.stringify(post)
//     };

//     const {
//         data,
//         error,
//         isLoading,
//     } = useQuery(
//         { 
//             queryKey: ['home'], 
//             queryFn: async () => {
//             fetch(Config.domain+url, requestOptions).then((res) => {
//                 res.json();
//             });
//         }
//     }); 

//     return data;

// }

export function Loader({styles}) { 
    return (
        <div style={styles} className='LoaderBox'>
            <span className="loader"></span>
        </div>
    );
}

export function IsJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return JSON.parse(str);
}

export function totalPrice(data) {

    let adons = 0;
    data?.selectedOptions?.map((v) => {
        if (v?.type == "count"){
            adons += Number(v?.price) * v?.val; 
        } else {
            adons += Number(v?.price)
        }
    });

    let total = (Number(data?.price) + adons) * data?.num;

    return total;
}

export async function allCartPrice(data, info, tax_included) {
    
    let arr = {};
    let subtotal = 0;
    let discount = 0;
    let tax = 0;
    data?.map((v) => {
        subtotal += Number(totalPrice(v));
    });

    if (info?.discount) {
        discount = (info?.discount * subtotal) / 100;
    }


    if (info?.tax) {
        tax = (info?.tax * (subtotal - discount)) / 100;
    }

    if (tax_included) {
        tax = 0;
    }

    arr.total = priceFormat((subtotal - discount) + tax);
    arr.subtotal = priceFormat(subtotal);
    arr.discount = priceFormat(discount);
    arr.tax = priceFormat(tax);

    return arr;
}


export async function UploadFile(file) { 

    async function upload(base) { 

        var reader = new FileReader();

        return new Promise(resolve => {
            reader.onload = ev => {
              resolve(reader.result)
            }
            reader.readAsDataURL(base)
        })
    }

    let arr = [];

    if (file.target.files?.length) {

        await Promise.all(
            Array.from(file.target.files)?.map(async (v, k) => {

                let splitFormatsAllowed = Config?.formatAllowed?.split(",");
                let ck = splitFormatsAllowed?.filter(r => r == v?.type);
                if (ck?.length) {
                    let r = await upload(v);
                    arr.push(r);
                } else {
                    arr = { error: "Image format is not allowed!!" };
                }
            })
        )

    }

    return arr;

    
}

export function Image({src, style}) {
    if (!src) {
        return (
            <img src="/Files/nopic.jpg" style={style} />
        );
    } else {
        return (
            <img src={src} style={style} />
        );
    }
    
}

export function priceFormat(number) {

    let USDollar = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits:2 }).format(Number(number));

    // return Number(number).toFixed(2);
    return USDollar;
}

export function numberFormat(number) {
    
    let num = Number(number);

    if (num >= 1000 && num < 1000000) {
        num = (num / 1000).toFixed(1) + "K";
    } else if (num >= 1000000 ) {
        num = (num / 1000000).toFixed(1) + "M";
    }

    return num;
}

export function DateToText({time, type}) {

    const { t } = useTranslation();
    const now = Date.now();

    let timer = (now - time);
    let diff = parseInt(timer / 60 / 1000);   
    if (isNaN(diff)) {
        timer = (now - new Date(time).getTime());
        diff = parseInt(timer / 60 / 1000);
    }

    let formattedDate;

    if (type == "date") {
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit'});
        return formattedDate;
    } else if (type == "datetime") {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
        return formattedDate;
    }
    
    if (diff < 0) {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
    } else {
        
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });

        if (diff < 1) {
            formattedDate = t("now");
        } else if (diff < 60 && diff >= 1) {
            formattedDate = `${t("bofore")} ${diff} ${t("minutes")}`;
        } else if (diff >= 60 && diff < 1440) {
            formattedDate = `${t("bofore")} ${parseInt(timer / 60 / 60 / 1000)} ${t("hours")}`;
        }

        // console.log(diff);
    }

    return (
        <>{formattedDate}</>
    );

}

export function dateToText(time, type) {
    

    const now = Date.now();

    let timer = (now - time);
    let diff = parseInt(timer / 60 / 1000);   
    if (isNaN(diff)) {
        timer = (now - new Date(time).getTime());
        diff = parseInt(timer / 60 / 1000);
    }

    let formattedDate;

    if (type == "date") {
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit'});
        return formattedDate;
    } else if (type == "datetime") {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
        return formattedDate;
    }
    
    if (diff < 0) {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
    } else {
        
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });

        if (diff < 1) {
            formattedDate = "Now";
        } else if (diff < 60 && diff >= 1) {
            formattedDate = `${diff} Minutes ago`;
        } else if (diff >= 60 && diff < 1440) {
            formattedDate = `${parseInt(timer / 60 / 60 / 1000)} Hours ago`;
        }

        // console.log(diff);
    }
    
    

    return formattedDate;
}
